<ng-template #wordingOrInstructionMedia>
  @if (guessWordingOrInstructionMedia$ | async; as media ) {
    <div class="activity-sample__window-infos multi-media wordingOrInstructionImage">
      <div class="activity-sample__preview">
        <div>
          @if (media.type === 'image') {
            <img
              [src]="media.uri"
              [alt]="media.alt">
          }
          @if (media.type === 'flashcard') {
            <img
              [src]="media.uri"
              [alt]="media.alt">
          }
          @if (media.type === 'video') {
            <video
            [src]="media.uri"></video>
          }
        </div>
      </div>
      <mat-icon [svgIcon]="'activity-sample__' + media.type"></mat-icon>
      @if (media.count > 1) {
        <span>{{ media.count }} {{ 'activity_sample.media_flashcards' | translate }}</span>
      }
    </div>
  }
</ng-template>


<ng-template #genericMultipleChoice let-typologyLabel>
  <ng-container *ngTemplateOutlet="wordingOrInstructionMedia"></ng-container>
  <div [ngClass]="{' multi-media': isWordingExist()}" class="activity-sample__overlay-infos genericMultipleChoice">
    @if (areAnswersAreImage(getAnswers())) {
      <mat-icon svgIcon='activity-sample__image'></mat-icon>
      <span>{{ getAnswers().length }} {{ 'activity_sample.' + typologyLabel + '_images' | translate }}</span>
    }
    @if (areAnswersAreText(getAnswers())) {
      <mat-icon
      [svgIcon]="getTypology() === TypologyLabel.shortAnswer ? 'activity-sample__keyboard' : 'activity-sample__text'"></mat-icon>
      <span>{{ getAnswers().length }} {{ 'activity_sample.' + typologyLabel + '_texts' | translate }}</span>
    }
    @if (areAnswersAreAudio(getAnswers())) {
      <mat-icon svgIcon='activity-sample__audio'></mat-icon>
      <span>{{ getAnswers().length }} {{ 'activity_sample.' + typologyLabel + '_audios' | translate }}</span>
    }
    @if (areAnswserAreFlashcards(getAnswers())) {
      <mat-icon svgIcon='activity-sample__flashcard'></mat-icon>
      @if (getAnswers().length > 1) {
        <span
        >{{ getAnswers().length }} {{ 'activity_sample.' + typologyLabel + '_flashcards' | translate }}</span>
      }
    }
    @if (undefinedAnswersType(getAnswers())) {
      <mat-icon svgIcon='activity-sample__undefined'></mat-icon>
      <span>{{ getAnswers().length }} {{ 'activity_sample.' + typologyLabel + '_undefined_type' | translate }}</span>
    }
  </div>
</ng-template>

<!--multipleChoiceUniqueAnswer-->
@if (getTypology() === TypologyLabel.multipleChoiceUniqueAnswer) {
  <ng-container
    *ngTemplateOutlet="genericMultipleChoice; context: {$implicit: TypologyLabel.multipleChoiceUniqueAnswer}">
  </ng-container>
}
<!--trueFalse-->
@if (getTypology() === TypologyLabel.trueFalse) {
  <ng-container *ngTemplateOutlet="wordingOrInstructionMedia"></ng-container>
  <div class="activity-sample__overlay-infos activity-sample__typology-trueFalse cc trueFalse">
    <mat-icon svgIcon="thumb_up"></mat-icon>
    /
    <mat-icon svgIcon="thumb_down"></mat-icon>
  </div>
}
<!--textMatching-->
@if (getTypology() === TypologyLabel.textMatching) {
  <div class="activity-sample__preview activity-sample__text-matching">
    @if (getSourceTypeOfTextMatching() === 'audio') {
      <div
        class="activity-sample__text-matching-audio">
        <mat-icon svgIcon='activity-sample__audio'></mat-icon>
        <span>{{ getSourcesOfTextMatching().length }} {{ 'activity_sample.audios' | translate }}</span>
      </div>
    }
    @if (getSourceTypeOfTextMatching() === 'img') {
      <div
        class="activity-sample__text-matching-image">
        <div [innerHtml]="getAnswers()[0].source"></div>
        <mat-icon svgIcon='activity-sample__image'></mat-icon>
        <span>{{ getSourcesOfTextMatching().length }} {{ 'activity_sample.images' | translate }}</span>
      </div>
    }
    @if (getSourceTypeOfTextMatching() === 'text') {
      <div
        class="activity-sample__text-matching-text">
        <mat-icon svgIcon='activity-sample__text'></mat-icon>
        <span>{{ getSourcesOfTextMatching().length }} {{ 'activity_sample.texts' | translate }}</span>
      </div>
    }
    @if (getTargetTypeOfTextMatching() === 'audio') {
      <div
        class="activity-sample__text-matching-audio">
        <mat-icon svgIcon='activity-sample__audio'></mat-icon>
        <span>{{ getTargetsOfTextMatching().length }} {{ 'activity_sample.audios' | translate }}</span>
      </div>
    }
    @if (getTargetTypeOfTextMatching() === 'img') {
      <div
        class="activity-sample__text-matching-image">
        <div [innerHtml]="getAnswers()[0].target"></div>
        <mat-icon svgIcon='activity-sample__image'></mat-icon>
        <span>{{ getTargetsOfTextMatching().length }} {{ 'activity_sample.images' | translate }}</span>
      </div>
    }
    @if (getTargetTypeOfTextMatching() === 'text') {
      <div
        class="activity-sample__text-matching-text">
        <mat-icon svgIcon='activity-sample__text'></mat-icon>
        <span>{{ getTargetsOfTextMatching().length }} {{ 'activity_sample.texts' | translate }}</span>
      </div>
    }
    <mat-icon class="activity-sample__text-matching-icon"
      svgIcon='activity-sample__matching'>
    </mat-icon>
  </div>
}
<!--multipleChoice-->
@if (getTypology() === TypologyLabel.multipleChoice) {
  <ng-container
    *ngTemplateOutlet="genericMultipleChoice; context: {$implicit: TypologyLabel.multipleChoice}">
  </ng-container>
}
<!--multimedia-->
@if (getTypology() === TypologyLabel.multimedia) {
  @for (granule of getMultimediaActivityMedias(); track granule) {
    @if (granule?.file?.type === 'image') {
      <div [ngClass]="{' multi-media': isWordingExist() || getMultimediaActivityMedias().length > 1}"
        class="activity-sample__window-infos activity-sample__multimedia-image">
        <div class="activity-sample__preview"><img [alt]="granule.file?.alt" [src]="granule.file?.uri"></div>
        <mat-icon svgIcon='activity-sample__image'></mat-icon>
      </div>
    }
    @if (granule?.file?.type === 'audio') {
      <div [ngClass]="{' multi-media': isWordingExist() || getMultimediaActivityMedias().length > 1}"
        class="activity-sample__overlay-infos activity-sample__multimedia-audio">
        <mat-icon svgIcon='activity-sample__audio'></mat-icon>
        <app-audio-time [src]="granule.file?.uri"></app-audio-time>
      </div>
    }
    @if (granule?.file?.type === 'video') {
      <div [ngClass]="{' multi-media': isWordingExist()}"
        class="activity-sample__window-infos activity-sample__multimedia-video">
        <div class="activity-sample__preview">
          <app-shared-video
            [video]="{uri: granule.file?.uri, filemime: granule.file?.filemime, subtitles: {}}"
            controls>
          </app-shared-video>
        </div>
        <mat-icon svgIcon='activity-sample__video'></mat-icon>
        <app-video-time [src]="granule.file?.uri"></app-video-time>
      </div>
    }
    @if (granule?.file?.type === 'document') {
      <div [ngClass]="{' multi-media': isWordingExist() || getMultimediaActivityMedias().length > 1}"
        class="activity-sample__overlay-infos activity-sample__multimedia-document">
        <mat-icon svgIcon='activity-sample__document'></mat-icon>
        <span>{{ granule.file.filename }}</span>
      </div>
    }
  }
  @if (isWordingExist() && isOnlyImagesMedia() === false) {
    <div [ngClass]="{' multi-media': getMultimediaActivityMedias().length > 0 }"
      class="activity-sample__window-infos activity-sample__multimedia-text">
      <div class="activity-sample__preview">{{ getWording() }}</div>
      <mat-icon svgIcon='activity-sample__text'></mat-icon>
    </div>
  }
}

<!--sortMat areAnswersAreImage-->
@if (getTypology() === TypologyLabel.sortMat && areAnswersAreImage(getAnswers())) {
  <div class="activity-sample__preview activity-sample__image-ordering"
    [class]="'imgCounter-' + getAnswers().length">
    @for (answer of getAnswers(); track answer) {
      <img [src]="answer.image"
        alt="{{ 'activities.alt_img_sort_mat' | translate }}">
      }
    </div>
  }
  <!--sortMat areAnswersAreText-->
  @if (getTypology() === TypologyLabel.sortMat && areAnswersAreText(getAnswers())) {
    @if (getTypeOfSortMatActivity() === 'orderSentence') {
      <div class="activity-sample__preview activity-sample__short-text-ordering">
        <div>
          <span>"</span>
          @for (answer of getAnswers(); track answer; let isLast = $last) {
            <span>{{ answer.answer }}</span>
            @if (!isLast) {
              <span>&nbsp;</span>
            }
          }
          <span>"</span>
        </div>
      </div>
    } @else {
      <div class="activity-sample__preview activity-sample__long-text-ordering">
        @for (answer of getAnswers(); track answer; let isLast = $last) {
          <div>
            <span>{{ answer.answer }}</span>
            @if (!isLast) {
              <span>,</span>
            }
            @if (isLast) {
              <span>.</span>
            }
          </div>
        }
      </div>
    }
  }
  <!--sortMat areAnswersAreAudio-->
  @if (getTypology() === TypologyLabel.sortMat && areAnswersAreAudio(getAnswers())) {
    <div class="activity-sample__preview activity-sample__audio-ordering">
      @for (answer of getAnswers(); track answer; let i = $index) {
        <mat-icon svgIcon='activity-sample__audio'></mat-icon>
      }
    </div>
  }

  <!--shortAnswer-->
  @if (getTypology() === TypologyLabel.shortAnswer) {
    @if (isLongAnswerCRT()) {
      <mat-icon svgIcon='activity-sample__keyboard' class="full-icon"></mat-icon>
    }
    @if (!isLongAnswerCRT()) {
      @if (guessWordingOrInstructionMedia$ | async; as image) {
        <ng-container
        *ngTemplateOutlet="genericMultipleChoice; context: {$implicit: TypologyLabel.shortAnswer}"></ng-container>
      } @else {
        <div class="activity-sample__overlay-infos activity-sample__multiShortAnswersTemplate">
          <mat-icon svgIcon='activity-sample__keyboard'></mat-icon>
          @if (getAnswers().length > 1) {
            <div class="grid-multi-answers">
              @for (answer of getAnswers(); track answer; let i = $index) {
                <div class="activity-sample__short-answer_multi">
                  <span>{{ answer.answer }}</span>
                </div>
              }
            </div>
          }
          @if (getAnswers().length === 1) {
            <span>{{ getAnswers()[0].answer }}</span>
          }
        </div>
      }
    }
  }
  <!--fillBlanks-->
  @if (getTypology() === TypologyLabel.fillBlanks) {
    <div class="activity-sample__preview activity-sample__fill-blanks">
      <mat-icon svgIcon='activity-sample__keyboard'></mat-icon>
      <span>
        "
        @for (textPart of getFillBlanksTextParts(); track textPart) {
          @if (textPart.isBlank) {
            <strong>{{ textPart.text }}</strong>
          }
          @if (!textPart.isBlank) {
            {{ textPart.text }}
          }
        }
        "
      </span>
    </div>
  }

  <!--awareness-->
  @if (getTypology() === TypologyLabel.awareness) {
    <div class="activity-sample__preview activity-sample__awareness">
      @for (flashcard of getFlashcardActivity(); track flashcard; let imgIndex = $index) {
        <img [alt]="flashcard.image?.alt" src="{{flashcard.image?.uri}}">
      }
    </div>
  }

  <!--memory-->
  @if (getTypology() === TypologyLabel.memory) {
    <div class="activity-sample__preview activity-sample__memory">
      @for (flashcard of getFlashcardActivity(); track flashcard; let imgIndex = $index) {
        <div class="activity-sample__memory-image-wrapper">
          <img class="activity-sample__memory-image"
            src="{{flashcard.image?.uri}}"
            [alt]="flashcard.image?.alt">
            <div class="activity-sample__memory-placeholder"
              aria-hidden="true">
            </div>
          </div>
        }
      </div>
    }
    <!--missing-->
    @if (getTypology() === TypologyLabel.missing || getTypology() === TypologyLabel.missingAudio) {
      <div class="activity-sample__preview activity-sample__missing-item">
        <div>
          @for (answer of getAnswers(); track answer) {
            <div>
              <img [src]="answer.image"
                alt="{{'activities.alt_img_missing_audio' | translate }}">
              </div>
            }
          </div>
          @if (getTypology() === TypologyLabel.missing) {
            <div class="activity-sample__overlay-infos multi-media">
              <mat-icon svgIcon='activity-sample__text'></mat-icon>
              <span>{{ getAnswers().length }} {{ 'activity_sample.text_answers' | translate }}</span>
            </div>
          } @else {
            <div class="activity-sample__overlay-infos">
              <mat-icon svgIcon='activity-sample__audio'></mat-icon>
              <span>{{ getAnswers().length }} {{ 'activity_sample.audio_answers' | translate }}</span>
            </div>
          }
        </div>
      }
      <!--recording-->
      @if (getTypology() === TypologyLabel.recording) {
        <div class="activity-sample__preview activity-sample__recording"
          [class.activity-sample__recording--missing-image]="!guessWordingOrInstructionMedia$">
          @if (guessWordingOrInstructionMedia$ | async; as image) {
            <img
              [src]="image.uri"
              [alt]="image.alt">
          }
          <mat-icon svgIcon='activity-sample__microphone'></mat-icon>
        </div>
      }
      <!--pointImage-->
      @if (getTypology() === TypologyLabel.pointImage) {
        <div class="activity-sample__preview activity-sample__point-image"
          [class.activity-sample__point-image--missing-image]="!guessWordingOrInstructionMedia$">
          @if (guessWordingOrInstructionMedia$ | async; as image) {
            <img
              [src]="image.uri"
              [alt]="image.alt">
          }
          <mat-icon svgIcon='activity-sample__image-search'></mat-icon>
        </div>
      }
      <!-- external-->
      @if (getTypology() === TypologyLabel.external) {
        <!-- si un fichier média est présent des les files on affiche le préview média -->
        @if (getExternalActivityMedia(); as media) {
          <img
            [src]="media.uri"
            [alt]="media.alt"
            >
          } @else {
            <div class="activity-sample__preview activity-sample__external">
              <mat-icon svgIcon="activity-sample__portal"></mat-icon>
            </div>
          }
        }
        <!--tool-->
        @if (getTypology() === TypologyLabel.tool) {
          <div class="activity-sample__preview activity-sample__tool">
            <mat-icon svgIcon="activity-sample__tools"></mat-icon>
            @if (getTypeOfToolActivity() === 'bd') {
              <span>
                {{ 'activity_sample.bd' | translate }}
              </span>
            }
            @if (getTypeOfToolActivity() === 'mindmap') {
              <span>
                {{ 'activity_sample.mindmap' | translate }}
              </span>
            }
            @if (getTypeOfToolActivity() === 'notepad') {
              <span>
                {{ 'activity_sample.notepad' | translate }}
              </span>
            }
          </div>
        }